export enum ChatFeedback {
  Unhelpful = -1,
  Neutral = 0,
  Helpful = 1,
}

export enum ChatSender {
  User = 'user',
  Assistant = 'assistant',
}

export interface ChatMessage {
  sender: ChatSender;
  text: string;
  timestamp: Date;
  turnId?: string;
}

export interface SuggestedQuestion {
  question: string;
}


export interface ChatHistoryItem {
  role: ChatSender;
  content: string;
}

export interface ChatRequest {
  question: string;
  history: ChatHistoryItem[];
  conversation_id: string | null;
}

export interface ChatToolCall {
  tool: string;
  inputs: Record<string, any>;
  success: boolean;
  error: string | null;
  result: Record<string, any>;
  latency_ms: number;
}

export interface ChatTrace {
  turn_id: string;
  answer: string;
  tool_calls: ChatToolCall[];
}

export interface ChatResponse {
  answer: string;
  conversation_id: string;
  trace: ChatTrace;
}

export interface FeedbackRequest {
  // Named conversation_id by the API, but it must be populated with trace.turn_id,
  // not the session's conversation_id - see AskSolvpathService.submitFeedback().
  conversation_id: string;
  rating: ChatFeedback;
  comment?: string;
}

export interface SessionSummary {
  id: string;
  title: string | null;
  started_at: string;
  last_message_at: string | null;
  ended_at: string | null;
  ended_reason: string | null;
  message_count: number;
  archived: boolean;
}

export interface ConversationMessage {
  id: number;
  role: ChatSender;
  content: string;
  turn_idx: number;
  created_at: string;
  turn_id: string;
}

export interface ConversationDetail extends SessionSummary {
  messages: ConversationMessage[];
}

export interface ChatFile {
  id: string;
  conversation_id: string;
  uploaded_by_user_id: number;
  filename: string;
  content_type: string;
  size_bytes: number;
  sha256: string;
  kind: string;
  sheet_names: string[] | null;
  schema_snapshot: any;
  sample_rows: any;
  anthropic_file_id: string | null;
  uploaded_at: string;
  purged_at: string | null;
  purge_reason: string | null;
}

export const AllowedFileExtensions: string[] = ['.xlsx', '.xls', '.csv', '.pdf', '.md', '.txt'];
export const MaxFileSizeBytes: number = 50 * 1024 * 1024;
export const MaxFilesPerConversation: number = 5;

export const SuggestedQuestions: SuggestedQuestion[] = [
  { question: 'How is retention rate calculated?' },
  { question: 'What does "cancel requests" count?' },
  { question: 'How is save rate calculated?' },
  { question: 'What is the difference between full refund rate and partial refund rate?' },
];

export const Emojis: string[] = [
  '😀', '😁', '😂', '🤣', '😊', '😍', '😘', '😜',
  '🤔', '😎', '😢', '😅', '🙌', '👍', '👏', '🙏',
  '🎉', '❤️', '🔥', '👌', '💡', '✅', '⚠️', '📊',
];